/* ═ ═ ═ ═ ═ ═ ═ ═ ═ *\
|      CORE LIBS      |
\* ═ ═ ═ ═ ═ ═ ═ ═ ═ */
// import "core-js";


import _ from "lodash";
import Vue from "vue";

import Element from "element-ui";
//import locale from "element-ui/lib/locale/lang/en";
import en from "@/el-ui-locales/en";
// import mk from "@/el-ui-locales/mk";
// import bg from "@/el-ui-locales/bg";

import Vuebar from "vuebar";

import "bootstrap/dist/css/bootstrap.css";

/* ═ ═ ═ ═ ═ ═ ═ ═ ═ *\
|  THIRD PARTS LIBS   |
\* ═ ═ ═ ═ ═ ═ ═ ═ ═ */
import VueI18n from "vue-i18n";

import "flag-icon-css/css/flag-icon.css";
import { getLanguage } from "@/globalFunctions/utilityFunctions";

import Fullscreen from "vue-fullscreen";

/* ═ ═ ═ ═ ═ ═ ═ ═ ═ *\
|     CORE ASSETS     |
\* ═ ═ ═ ═ ═ ═ ═ ═ ═ */

import "./assets/scss/global.scss";
import "flex.box";
import "animate.css";

import "../node_modules/@mdi/font/css/materialdesignicons.min.css";
import App from "./App.vue";
import router from "./router/";
import store from "./store";
import i18n_messages from "./i18n";

try {
  const value = localStorage.getItem('recaptchaStatus');
  if (value && typeof value === 'string') {
    // Try to parse, remove if invalid JSON
    JSON.parse(value);
  }
} catch (e) {
  //localStorage.removeItem('recaptchaStatus');
}


import { VueReCaptcha } from 'vue-recaptcha-v3'
Vue.config.productionTip = false;

/* ═ ═ ═ ═ ═ ═ ═ ═ ═ ═ ═ *\
|  THIRD PARTS COMPONENTS |
\* ═ ═ ═ ═ ═ ═ ═ ═ ═ ═ ═ */

Vue.use(VueI18n);

/* ═ ═ ═ ═ ═ ═ ═ ═ *\
|  CORE COMPONENTS  |
\* ═ ═ ═ ═ ═ ═ ═ ═ */
Vue.use(Vuebar);

Vue.use(Fullscreen);

const initialLanguage = getLanguage();
export const i18n = new VueI18n({
  locale: initialLanguage,
  messages: i18n_messages,
});

//console.log("main.js -> i18n.locale:", i18n.locale);
//Vue.use(Element, { locale: en });
Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})
//export function switchElementUILang(lang) {
//  switch(lang){
//    case 'mk': Vue.use(Element, { locale: mk }); break;
//    case 'bg': Vue.use(Element, { locale: bg }); break;
//    default: Vue.use(Element, { locale: en });
//  }
//  console.log("El UI lang switched to:", lang);
//}

//switchElementUILang(initialLanguage);
Vue.use(VueReCaptcha, {
  
  siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY, 
  loaderOptions: {
    useRecaptchaNet: true, 
    autoHideBadge: true,
  }
});
new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
